import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import CobroNotesList from './CobroNotesList';
import CobroNoteDetail from './CobroNoteDetail';
import CobranzaView from './CobranzaView';
import '../billing/billing.scss';

// Notas de cobro a comercios. "Pago a repartidores" fue una pestaña hermana
// acá hasta ago-2026; hoy es módulo propio en /admin/pago-repartidores (son
// dos negocios distintos: cobrar a comercios vs pagar a la flota). El redirect
// conserva bookmarks y enlaces viejos. "Facturación" (SII, documentos
// tributarios) será un módulo aparte cuando exista.
//
// La configuración del proveedor de pago vive en /admin/settings →
// Integraciones → Pagos (PaymentIntegrationsSection).
//
// "cobranza" (vencimientos y recordatorios) es un segmento literal: en react-router 6 un
// segmento estático tiene más rango que `:id`, así que nunca se interpreta como una nota.
const CobroView = () => (
  <div className="bill">
    <Routes>
      <Route index element={<CobroNotesList />} />
      <Route path="driver-payments" element={<Navigate to="/admin/pago-repartidores" replace />} />
      <Route path="cobranza" element={<CobranzaView />} />
      <Route path=":id" element={<CobroNoteDetail />} />
    </Routes>
  </div>
);

export default CobroView;
